import React, {useState, useCallback, useEffect, useRef} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import styles from './dropdown.module.css';

function DropdownMenu(props) {
    const {list, getOptionLabel, data = null} = props;
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    }, []);

    const onDropdownClick = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    const positionClass = useCallback(() => {
        if(props.position === 'right') {
            return styles.dropdownPositionRight;
        }
        return '';
    }, []);

    return <>
        <div ref={wrapperRef} className={classNames(styles.dropdown)} style={{border: 'none', padding: 0, background: 'none', display: 'flex', alignItems: 'center'}} onClick={onDropdownClick}>
            <div style={{display: 'flex', alignItems: 'center'}}>
                {props.children}
            </div>
            <div className={classNames(styles.dropdownMenu, positionClass(), isOpen && styles.displayBlock)}>
                {list.map((option, idx) => {
                    const label = getOptionLabel ? getOptionLabel(option, idx) : option.label;
                    return <div key={uuidv4()} className={styles.dropdownMenuItem} onClick={() => {
                        setIsOpen(false);
                        props.onChange(option, idx, option);
                    }}>
                        <div style={{flex: 1}}>
                            {label}
                        </div>
                    </div>
                })}
            </div>
        </div>
    </>
}

DropdownMenu.propTypes = {
    list: PropTypes.array,
    getOptionLabel: PropTypes.func,
    data: PropTypes.object,
};

export default DropdownMenu;

